// extracted by mini-css-extract-plugin
export default {"root":"PromotionSection_root__a-Bl8","title":"PromotionSection_title__DwhxG","transparentBtn":"PromotionSection_transparentBtn__4Kwec"};